<template>
  <div id="app">
    <ConfirmModal />
    <Notification />
    <router-view />
  </div>
</template>

<script>	
  import ConfirmModal from '@/shared/components/modals/ConfirmModal'
  import Notification from "@/shared/components/Notification"

	export default {
    
    components : {
      ConfirmModal,
      Notification
    },
    
    metaInfo () {
      return {
        title: 'Brokerpad',

        // all titles will be injected into this template
        titleTemplate: (titleChunk) => {
          return titleChunk ? `${titleChunk} - ` + this.getAppName : this.getAppName;
        },
      }
    }
	}
</script>
